import { createAction, props } from '@ngrx/store';

import { Bank } from "app/modules/products/_state/products.interfaces"
import { EditRecipientDto, RecipientCategoryDto, RecipientDto, UpdateTransactionStatusDto } from "./bulk-top-up.dtos"
import { Country, Recipient, RecipientCategory, XcelAccount } from "./bulk-top-up.interfaces"

export const fetchCountries = createAction(
    '[Bulk Top-Up Module] fetch countries'
)

export const fetchCountriesFailed = createAction(
    '[Bulk Top-Up Module] STATUS: fetch countries failed'
)

export const fetchCountriesSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: fetch countries success',
    props<{countries: Country[]}>()
)


export const fetchRecipientCategories = createAction(
    '[Bulk Top-Up Module] fetch recipient categories',
    props<{ page: number; limit: number }>()
)

export const fetchRecipientCategoriesFailed = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipient categories failed'
)

export const fetchRecipientCategoriesSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipient categories success',
 props<{recipientCategories: RecipientCategory[]; pagination: any}>()
)


export const createRecipientCategory = createAction(
    '[Bulk Top-Up Module] create recipient category',
    props<{recipientCategoryDto: RecipientCategoryDto}>()
)

export const createRecipientCategoryFailed = createAction(
    '[Bulk Top-Up Module] STATUS: create recipient category failed'
)

export const createRecipientCategorySuccess = createAction(
    '[Bulk Top-Up Module] STATUS: create recipient category success'
)


export const fetchRecipients = createAction(
    '[Bulk Top-Up Module] fetch recipients'
)

export const fetchRecipientsFailed = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipients failed'
)

export const fetchRecipientsSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipients success',
    props<{recipients: Recipient[]}>()
)


export const fetchRecipientsByCategory = createAction(
    '[Bulk Top-Up Module] fetch recipients by category',
    props<{categoryId: string}>()
)

export const fetchRecipientsByCategoryFailed = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipients by category failed'
)

export const fetchRecipientsByCategorySuccess = createAction(
    '[Bulk Top-Up Module] STATUS: fetch recipients by category success',
    props<{recipients: Recipient[]}>()
)


export const createRecipient = createAction(
    '[Bulk Top-Up Module] create recipient',
    props<{recipientDto: RecipientDto}>()
)

export const createRecipientFailed = createAction(
    '[Bulk Top-Up Module] STATUS: create recipient failed'
)

export const createRecipientSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: create recipient success'
)


export const editRecipient = createAction(
    '[Bulk Top-Up Module] edit recipient',
    props<{recipientDto: EditRecipientDto}>()
)

export const editRecipientFailed = createAction(
    '[Bulk Top-Up Module] STATUS: edit recipient failed'
)

export const editRecipientSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: edit recipient success'
)


export const validateXcelAccount = createAction(
    '[Bulk Top-Up Module] validate xcel account',
    props<{walletNumber: string, schemeCode: string}>()
)

export const validateXcelAccountFailed = createAction(
    '[Bulk Top-Up Module] STATUS: validate xcel account failed'
)

export const validateXcelAccountSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: validate xcel account success',
    props<{xcelAccount: XcelAccount}>()
)


export const fetchAccountBalance = createAction(
    '[Bulk Top-Up Module] fetch account balance',
    props<{accountIdentifier: string}>()
)

export const fetchAccountBalanceFailed = createAction(
    '[Bulk Top-Up Module] STATUS: fetch account balance failed'
)

export const fetchAccountBalanceSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: fetch account balance success',
    props<{balance}>()
)


export const sendOTP = createAction(
    '[Bulk Top-Up Module] send OTP',
    props<{accountIdentifier: string}>()
)

export const sendOTPFailed = createAction(
    '[Bulk Top-Up Module] STATUS: send OTP failed'
)

export const sendOTPSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: send OTP success',
    props<{otpInfo}>()
)


export const deleteRecipient = createAction(
    '[Bulk Top-Up Module] delete recipient',
    props<{recipientId: string}>()
)

export const deleteRecipientFailed = createAction(
    '[Bulk Top-Up Module] STATUS: delete recipient failed'
)

export const deleteRecipientSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: delete recipient success'
)

export const updateTransactionStatus = createAction(
    '[Bulk Top-Up Module] update transaction status',
    props<{ updateTransactionStatusDto: UpdateTransactionStatusDto | [], transactionId: string, paymentId: string, status: string}>()
)

export const updateTransactionStatusFailed = createAction(
    '[Bulk Top-Up Module] STATUS: update transaction status failed'
)

export const updateTransactionStatusSuccess = createAction(
    '[Bulk Top-Up Module] STATUS: update transaction status success'
)

export const fetchRecipientBanks = createAction(
    '[Products Module] fetch recipient banks',
    props<{countryCode: string}>()
)

export const fetchRecipientBanksFailed = createAction(
    '[Products Module] STATUS: fetch recipient banks failed'
)

export const fetchRecipientBanksSuccess = createAction(
    '[Products Module] STATUS: fetch recipient banks success',
    props<{banks: Bank[]}>()
)